import {Injectable, signal} from '@angular/core';

@Injectable({providedIn: 'root'})
export class LayoutService {

  public theme = signal<'light' | 'dark'>('light');
  public mobileMenuOpen = signal(false);

  constructor() {
    const t = localStorage.getItem('theme') as 'light' | 'dark';

    if (!t) {
      const darkThemeQuery = window.matchMedia('(prefers-color-scheme: dark)');
      this.theme.set(darkThemeQuery.matches ? 'dark' : 'light');
    } else {
      this.theme.set(t);
    }
    
    // Initial update
    this.updateDom(this.theme());
  }

  private updateDom(theme: 'light' | 'dark') {
    localStorage.setItem('theme', theme);
    if (theme === 'dark') {
      document.documentElement.classList.add('app-dark');
    } else {
      document.documentElement.classList.remove('app-dark');
    }
  }

  public isDarkTheme(): boolean {
    return this.theme() === 'dark';
  }

  public toggleDarkMode() {
    const newTheme = this.theme() === 'dark' ? 'light' : 'dark';
    this.theme.set(newTheme);
    this.updateDom(newTheme);
  }

  public toggleMobileMenu() {
    this.mobileMenuOpen.update(v => !v);
  }
}
